<template>
	<div :class="styleClass">{{ index }}</div>
</template>

<script>
import { CONSTANTS } from '@/common/constants.js'

/**
 * Renders the question number icon. Used in the accordions and the in-row validation messages.
 */
export default {
  name: 'WesQuestionNumber',
  props: {
    index: String,
    type: String
  },
  computed: {
    styleClass () {
      if (this.type === CONSTANTS.QUESTION_NUMBER_TYPE.ERROR) {
        return 'ref-number-shared question-number-error';
      } else if (this.type === CONSTANTS.QUESTION_NUMBER_TYPE.TREND) {
        return 'ref-number-shared question-number-trend';
      } else {
        return 'question-number';
      }
    }
  }
};
</script>

<style scoped>
/* Question number default style, for accordions */
.question-number {
  float: left;
  background-color: #101010;
  border-radius: 50%;
  text-align: center;
  padding: 3px;
  width: 24px;
  color: white;
  line-height: 20px;
  height: 24px;
  font-size: 16px;
  font-weight: normal;
}

.ref-number-shared {
  float: left;
  border-radius: 50%;
  text-align: center;
  padding: 3px;
  width: 22px;
  line-height: 12px;
  height: 22px;
  font-size: 14px;
  border: 1px solid #101010;
}

/* Question number style for error validation messages */
.question-number-error {
  background-color:#c00000;
  color: white;
}
/* Question number style for trend validation messages */
.question-number-trend {
  background-color: #ffc000;
  color: black;
}
</style>
